import { useMutation } from "@tanstack/react-query";
import { ILeaveAReviewData } from "../types";
import { ReviewService } from "../../services/review.service";

export const useReviewMutations = () => {
  const { mutate: leaveAReview } = useMutation<any, Error, ILeaveAReviewData>({
    mutationFn: async (model: ILeaveAReviewData) =>
      ReviewService.leaveAReview(model).then((res) => res.data),
  });

  return {
    leaveAReview,
  };
};
